{
  "common": {
    "loading": "Carregando...",
    "cancel": "Cancelar",
    "save": "Salvar",
    "delete": "Excluir",
    "edit": "Editar",
    "close": "Fechar",
    "submit": "Enviar",
    "saving": "Salvando...",
    "sending": "Enviando...",
    "error": "Erro",
    "success": "Sucesso",
    "warning": "Aviso",
    "no_data": "Sem dados",
    "yes": "Sim",
    "no": "Não",
    "back": "Voltar",
    "next": "Próximo",
    "previous": "Anterior",
    "search": "Procurar",
    "filter": "Filtro",
    "all": "Todos",
    "none": "Nenhum",
    "select": "Selecione",
    "required": "Obrigatório",
    "optional": "Opcional",
    "actions": "Ações",
    "status": "Status",
    "date": "Data",
    "time": "Tempo",
    "name": "Nome",
    "email": "E-mail",
    "confirm": "Confirmar",
    "add": "Adicionar",
    "done": "Concluído",
    "unknown": "Desconhecido",
    "days": "dias",
    "to": "a",
    "save_changes": "Guardar alterações",
    "note": "Nota"
  },
  "time": {
    "day": "dia",
    "days": "dias",
    "hour": "hora",
    "hours": "horas",
    "week": "semana",
    "weeks": "semanas",
    "month": "mês",
    "months": "meses",
    "year": "ano",
    "years": "anos",
    "today": "Hoje",
    "tomorrow": "Amanhã",
    "yesterday": "Ontem"
  },
  "status": {
    "pending": "Pendente",
    "approved": "Aprovado",
    "rejected": "Rejeitado",
    "cancelled": "Cancelado",
    "active": "Ativo",
    "inactive": "Inativo",
    "deleted": "Excluído",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "available": "Disponível",
    "coming_soon": "Em breve"
  },
  "nav": {
    "dashboard": "Painel",
    "planner": "Planejador",
    "team": "Equipe",
    "requests": "Solicitações",
    "calendar": "Calendário",
    "settings": "Configurações",
    "audit_trail": "Registro de auditoria",
    "billing": "Cobrança",
    "help": "Ajuda",
    "help_center": "Central de ajuda",
    "profile": "Perfil",
    "my_balances": "Meus saldos",
    "leave_history": "Histórico de férias",
    "restart_tour": "Reiniciar tour",
    "logout": "Sair",
    "upgrade": "Faça o upgrade para a versão Pro.",
    "upgrade_subtitle": "Desbloqueie todas as funcionalidades",
    "view_plans": "Ver planos"
  },
  "header": {
    "profile_settings": "Configurações de perfil",
    "my_profile": "Meu perfil",
    "workspace": "Espaço de trabalho",
    "leave_balances": "Saldos de licença",
    "no_balances": "Nenhum saldo de férias encontrado."
  },
  "balance": {
    "unlimited": "Ilimitado",
    "days_left": "faltam poucos dias",
    "used": "usado",
    "remaining": "restante",
    "of": "de"
  },
  "trial": {
    "ends_today": "Seu período de teste termina hoje!",
    "ends_tomorrow": "Seu período de teste termina amanhã!",
    "ends_in_days": "O julgamento termina em {days} dias.",
    "upgrade_now": "Atualize agora"
  },
  "feature_locked": {
    "title": "{feature} não está disponível no seu plano.",
    "description": "Atualize seu plano para desbloquear esse recurso e muito mais.",
    "button": "Ver plantas"
  },
  "dashboard": {
    "title": "Painel",
    "out_today": "Já disponível",
    "out_on_date": "Saindo em {date}",
    "no_absences": "Sem faltas",
    "upcoming": "Ausências futuras",
    "upcoming_empty": "Sem ausências previstas para esta semana.",
    "my_balance": "Meu saldo de férias",
    "my_balances": "Meus saldos",
    "no_balance_data": "Sem dados de saldo",
    "next_holiday": "Próximo feriado",
    "no_holidays": "Não há feriados à vista",
    "next_vacation": "Minhas próximas férias",
    "nothing_booked": "Nada reservado!",
    "upcoming_birthdays": "Próximos aniversários",
    "no_birthdays": "Não há aniversários à vista",
    "birthday_today": "Hoje!",
    "birthday_in_days": "em {days} {unit}",
    "everyone_in_office": "Neste dia, todos estão no escritório.",
    "request_leave": "Solicitar licença",
    "view_calendar": "Ver calendário",
    "view_planner": "Ver Planejador",
    "contact_support": "Contate o suporte"
  },
  "support": {
    "title": "Contate o suporte",
    "success_title": "Mensagem enviada!",
    "success_message": "Entraremos em contato com você assim que possível.",
    "intro": "Precisa de ajuda? Envie-nos uma mensagem e entraremos em contato em breve.",
    "subject_label": "Assunto",
    "subject_placeholder": "Breve descrição do seu problema",
    "message_label": "Mensagem",
    "message_placeholder": "Por favor, descreva seu problema ou dúvida em detalhes...",
    "send_button": "Enviar mensagem"
  },
  "requests": {
    "page_title": "Pedidos de licença",
    "page_subtitle": "Analisar e gerir pedidos de férias",
    "new_request": "Solicitar licença",
    "unpaid_confirm": "Apenas {paid} {unit} deste pedido estão cobertos pelo seu saldo remunerado. As restantes {unpaid} {unit} serão tiradas como férias não remuneradas. Enviar mesmo assim?",
    "filter": {
      "pending": "Pendente",
      "approved": "Aprovado",
      "rejected": "Rejeitado",
      "all": "Todos",
      "all_employees": "Todos os funcionários"
    },
    "table": {
      "employee": "Funcionário",
      "type": "Tipo",
      "dates": "Datas",
      "duration": "Duração",
      "status": "Status",
      "reason": "Razão",
      "actions": "Ações"
    },
    "action": {
      "approve": "Aprovar",
      "reject": "Rejeitar",
      "cancel": "Cancelar"
    },
    "empty": {
      "title": "Nenhuma solicitação encontrada",
      "pending": "Não há solicitações pendentes para análise.",
      "filtered": "Nenhuma solicitação de licença corresponde ao seu filtro."
    },
    "modal": {
      "reject_title": "Rejeitar solicitação",
      "reason_label": "Motivo da rejeição",
      "reason_placeholder": "Motivo do pedido de licença...",
      "reject_button": "Rejeitar",
      "request_title": "Solicitar licença",
      "employee_label": "Funcionário",
      "leave_type_label": "Tipo de saída",
      "start_date_label": "Data de início",
      "end_date_label": "Data de término",
      "start_time_label": "Hora de início",
      "end_time_label": "Hora final",
      "reason_optional": "Motivo (opcional)",
      "submit_button": "Enviar solicitação",
      "submitting": "Enviando...",
      "minimum_duration": "Mínimo: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Calendário da Equipe",
    "page_subtitle": "Veja as ausências da equipe e as férias programadas.",
    "filters": {
      "button": "Filtros"
    },
    "sync": {
      "title": "Sincronize seu calendário",
      "description": "Conecte seu calendário pessoal para sincronizar automaticamente as férias aprovadas."
    },
    "connect": {
      "google": "Google Agenda",
      "microsoft": "Calendário da Microsoft"
    },
    "action": {
      "disconnect": "Desconectar",
      "sync_my_leave": "Sincronizar minhas férias",
      "sync_team_leave": "Equipe de Sincronização Sair"
    },
    "connecting": "Conectando...",
    "syncing": "Sincronizando...",
    "autosync": {
      "title": "A equipe de sincronização automática vai embora.",
      "description": "Adicione automaticamente as férias aprovadas dos membros da equipe ao seu calendário."
    },
    "filter": {
      "department_label": "Departamento",
      "all_departments": "Todos os departamentos",
      "location_label": "Localização",
      "all_locations": "Todas as localidades",
      "leave_type_label": "Tipo de saída",
      "all_types": "Todos os tipos",
      "status_label": "Status",
      "all_status": "Todos os status"
    },
    "nav": {
      "today": "Hoje"
    },
    "view": {
      "day": "Dia",
      "week": "Semana",
      "month": "Mês"
    },
    "legend": {
      "pending": "Pendente",
      "holiday": "Feriado"
    },
    "day_view": {
      "empty": "Sem folhas neste dia"
    },
    "more": "+{count} mais"
  },
  "team": {
    "page_title": "Equipa",
    "page_subtitle": "Gerir os membros da sua equipa",
    "add_user": "Adicionar utilizador",
    "import_from_slack": "Importar do Slack",
    "search_placeholder": "Procurar membros da equipa...",
    "tab": {
      "active": "Ativos",
      "inactive": "Inativos",
      "deleted": "Eliminados"
    },
    "table": {
      "name": "Nome",
      "email": "E-mail",
      "department": "Departamento",
      "location": "Localização",
      "role": "Função",
      "status": "Estado",
      "actions": "Ações",
      "manager": "Gestor",
      "start_date": "Data de início",
      "birthday": "Aniversário",
      "working_days": "Dias de trabalho",
      "balance": "Saldo"
    },
    "filter": {
      "all_departments": "Todos os departamentos",
      "all_locations": "Todas as localizações",
      "all_roles": "Todas as funções",
      "search": "Procurar"
    },
    "role": {
      "owner": "Proprietário",
      "admin": "Administrador",
      "approver": "Aprovador",
      "employee": "Colaborador"
    },
    "card": {
      "department": "Departamento",
      "location": "Localização",
      "manager": "Gestor",
      "start_date": "Data de início",
      "birthday": "Aniversário",
      "working_days": "Dias de trabalho",
      "no_manager": "Sem gestor",
      "no_department": "Sem departamento",
      "no_location": "Sem localização"
    },
    "action": {
      "edit": "Editar",
      "deactivate": "Desativar",
      "activate": "Ativar",
      "delete": "Eliminar",
      "restore": "Restaurar",
      "permanent_delete": "Eliminar permanentemente",
      "view_balances": "Ver saldos",
      "adjust_balance": "Ajustar saldo",
      "view_history": "Ver histórico"
    },
    "empty": {
      "title": "Nenhum membro da equipa",
      "active": "Não existem utilizadores ativos.",
      "inactive": "Não existem utilizadores inativos.",
      "deleted": "Não existem utilizadores eliminados.",
      "search": "Nenhum utilizador corresponde à sua pesquisa."
    },
    "modal": {
      "edit_title": "Editar utilizador",
      "add_title": "Adicionar utilizador",
      "name_label": "Nome",
      "email_label": "E-mail",
      "department_label": "Departamento",
      "location_label": "Localização",
      "role_label": "Função",
      "manager_label": "Gestor",
      "start_date_label": "Data de início",
      "birthday_label": "Aniversário",
      "working_days_label": "Dias de trabalho",
      "hours_per_week_label": "Horas por semana",
      "employment_type_label": "Tipo de contrato",
      "full_time": "Tempo inteiro",
      "part_time": "Tempo parcial",
      "contractor": "Contratado",
      "select_department": "Selecionar departamento",
      "select_location": "Selecionar localização",
      "select_manager": "Selecionar gestor",
      "no_manager": "Sem gestor"
    },
    "toil": {
      "title": "Folga compensatória",
      "add_button": "Adicionar TOIL",
      "hours_label": "Horas",
      "reason_label": "Motivo",
      "date_label": "Data",
      "balance": "Saldo TOIL"
    },
    "invite": {
      "title": "Convidar membro",
      "subtitle": "Enviar convite por e-mail",
      "email_label": "Endereço de e-mail",
      "send_button": "Enviar convite",
      "success": "Convite enviado com sucesso"
    },
    "bulk": {
      "title": "Importação em massa",
      "subtitle": "Importar vários utilizadores de uma vez",
      "import_button": "Importar utilizadores",
      "template_button": "Descarregar modelo",
      "csv_label": "Ficheiro CSV",
      "importing": "A importar...",
      "success": "{count} utilizadores importados com sucesso",
      "error": "Erro ao importar utilizadores"
    },
    "instances": {
      "title": "Instâncias de licença",
      "lifetime_used": "Utilizado ao longo da vida",
      "remaining": "Restante",
      "no_instances": "Sem instâncias registadas"
    },
    "confirm": {
      "deactivate": "Tem a certeza de que pretende desativar este utilizador?",
      "deactivate_warning": "O utilizador perderá o acesso ao sistema.",
      "delete": "Tem a certeza de que pretende eliminar este utilizador? Será movido para o separador Eliminados.",
      "permanent_delete": "Tem a certeza de que pretende ELIMINAR PERMANENTEMENTE {name}?",
      "permanent_delete_warning": "Esta ação é irreversível. Todo o histórico de licenças e saldos serão apagados.",
      "permanent_delete_final": "Esta ação é permanente! Clique em OK para confirmar a eliminação permanente.",
      "restore": "Tem a certeza de que pretende restaurar este utilizador?"
    },
    "error": {
      "deactivate": "Falha ao desativar o utilizador",
      "activate": "Falha ao ativar o utilizador",
      "delete": "Falha ao eliminar o utilizador",
      "restore": "Falha ao restaurar o utilizador",
      "permanent_delete": "Falha ao eliminar permanentemente o utilizador",
      "load": "Falha ao carregar os membros da equipa",
      "save": "Falha ao guardar o utilizador",
      "import": "Falha ao importar utilizadores"
    }
  },
  "settings": {
    "page_title": "Configurações",
    "page_subtitle": "Configure as definições e políticas do seu espaço de trabalho.",
    "access_denied": {
      "title": "Acesso de administrador necessário",
      "message": "Você precisa de permissões de administrador para acessar as configurações."
    },
    "tab": {
      "workspace": "Espaço de trabalho",
      "departments": "Departamentos",
      "locations": "Locais",
      "holidays": "Feriados",
      "compliance": "Conformidade",
      "balances": "Saldos iniciais",
      "notifications": "Notificações",
      "integrations": "Integrações",
      "import": "Importar",
      "data_management": "Gestão de Dados",
      "locked_tooltip": "Atualize para desbloquear este recurso."
    },
    "workspace": {
      "title": "Configurações do espaço de trabalho",
      "name_label": "Nome do espaço de trabalho",
      "visibility_label": "Deixe a visibilidade",
      "visibility": {
        "all": "Todos podem ver todos saindo",
        "department": "Veja apenas o seu próprio departamento.",
        "approvers": "Somente os aprovadores podem ver tudo."
      },
      "save_button": "Salvar alterações"
    },
    "departments": {
      "title": "Departamentos",
      "subtitle": "Organize sua equipe em departamentos com políticas personalizadas.",
      "add_button": "Adicionar Departamento",
      "name_label": "Nome do departamento",
      "working_days_label": "Dias úteis",
      "hours_per_day_label": "Horas por dia",
      "approvers_label": "Aprovadores",
      "notification_channel_label": "Canal de Notificação",
      "policies_button": "Gerenciar políticas",
      "edit_button": "Editar",
      "delete_button": "Excluir",
      "confirm_delete": "Tem certeza de que deseja excluir este departamento?",
      "no_departments": "Nenhum departamento foi criado ainda."
    },
    "locations": {
      "title": "Locais",
      "subtitle": "Gerenciar escritórios e seus respectivos calendários de feriados.",
      "add_button": "Adicionar localização",
      "name_label": "Nome do local",
      "country_label": "País",
      "timezone_label": "Fuso horário",
      "edit_button": "Editar",
      "delete_button": "Excluir",
      "no_locations": "Ainda não foram criados locais."
    },
    "holidays": {
      "title": "Feriados",
      "subtitle": "Gerenciar feriados para cada localidade",
      "add_button": "Adicionar feriado",
      "location_label": "Localização",
      "all_locations": "Todas as localidades",
      "year_label": "Ano",
      "name_label": "Nome do feriado",
      "date_label": "Data",
      "half_day_label": "Meio dia",
      "edit_button": "Editar",
      "delete_button": "Excluir",
      "no_holidays": "Não há feriados para este local e ano.",
      "import_button": "Feriados de Importação"
    },
    "leave_types": {
      "title": "Tipos de folhas",
      "subtitle": "Configurar tipos de licença e direitos",
      "add_button": "Adicionar tipo de saída",
      "name_label": "Nome",
      "color_label": "Cor",
      "unit_label": "Unidade",
      "unit": {
        "days": "Dias",
        "hours": "Horas"
      },
      "entitlement_label": "Direito padrão",
      "unlimited": "Ilimitado",
      "requires_approval_label": "Requer aprovação.",
      "allow_half_day_label": "Reserve meio dia.",
      "is_paid_label": "Licença remunerada",
      "carryover_label": "Transferência máxima",
      "priority_label": "Prioridade",
      "edit_button": "Editar",
      "delete_button": "Excluir",
      "no_leave_types": "Nenhum tipo de licença configurado"
    },
    "notifications": {
      "title": "Notificações",
      "subtitle": "Configure como e quando as notificações serão enviadas.",
      "slack_channel_label": "Canal do Slack",
      "email_notifications_label": "Notificações por e-mail",
      "daily_digest_label": "Resumo Diário",
      "weekly_summary_label": "Resumo semanal",
      "save_button": "Salvar configurações"
    },
    "integrations": {
      "title": "Integrações",
      "subtitle": "Conecte suas ferramentas de RH e calendários.",
      "connect_button": "Conectar",
      "disconnect_button": "Desconectar",
      "sync_button": "Sincronizar agora",
      "view_logs_button": "Ver registos",
      "last_sync": "Última sincronização: {date}",
      "never_synced": "Nunca sincronizado",
      "status": {
        "connected": "Conectado",
        "disconnected": "Não conectado",
        "error": "Erro"
      }
    },
    "data": {
      "title": "Gestão de Dados",
      "subtitle": "Faça backup dos seus dados ou limpe as informações do espaço de trabalho.",
      "current_data": "Dados atuais",
      "total_users": "Total de usuários",
      "admins": "Administradores",
      "regular_users": "Usuários regulares",
      "leave_requests": "Pedidos de licença",
      "backup": {
        "title": "Baixar backup",
        "description": "Faça o download de um backup completo dos dados do seu espaço de trabalho como um arquivo JSON.",
        "button": "Baixar backup"
      },
      "google_drive": {
        "title": "Backup do Google Drive",
        "description": "Cópias de segurança diárias automáticas para o Google Drive.",
        "connect_button": "Conectar o Google Drive",
        "folder_label": "Pasta de backup",
        "auto_backup_label": "Ativar backup diário automático",
        "backup_now_button": "Faça backup agora",
        "last_backup": "Último backup: {date}",
        "upgrade_message": "O plano Business oferece backups diários automáticos para o Google Drive."
      },
      "clear_users": {
        "title": "Limpar usuários sem privilégios de administrador",
        "description": "Remova todos os usuários, exceto administradores e proprietários. Isso excluirá {count} usuários, seus saldos de férias e quaisquer solicitações de férias pendentes.",
        "warning": "Aviso: Esta ação não pode ser desfeita. Certifique-se de baixar um backup primeiro.",
        "confirm_prompt": "Digite DELETE para confirmar.",
        "confirm_description": "Isso removerá permanentemente {count} usuários e todos os seus dados.",
        "button": "Limpar usuários sem privilégios de administrador",
        "confirm_button": "Confirmar exclusão de usuários"
      },
      "clear_history": {
        "title": "Limpar histórico de saídas",
        "description": "Remova todos os pedidos de férias e zere todos os saldos de férias. Isso excluirá {count} pedidos de férias.",
        "warning": "Aviso: Esta ação é irreversível. Todo o histórico de saídas será apagado permanentemente e os saldos serão zerados.",
        "confirm_description": "Isso excluirá permanentemente {count} solicitações de saída e redefinirá todos os saldos.",
        "button": "Limpar histórico de saídas",
        "confirm_button": "Confirme Limpar o histórico"
      },
      "restore": {
        "title": "Restaurar a partir do backup",
        "description": "Faça o upload de um arquivo JSON de backup para restaurar os dados do seu espaço de trabalho. Isso substituirá todos os dados existentes.",
        "warning": "Aviso: A restauração substituirá todos os usuários, tipos de licença, solicitações de licença, departamentos e saldos atuais. Somente o proprietário do espaço de trabalho pode executar esta ação.",
        "select_file": "Selecione o arquivo de backup",
        "backup_details": "Detalhes do backup",
        "file": "Arquivo",
        "version": "Versão",
        "created": "Criado",
        "confirm_prompt": "Digite RESTORE para confirmar.",
        "confirm_description": "Isso substituirá permanentemente todos os dados existentes pelo backup.",
        "button": "Confirmar restauração",
        "restoring": "Restaurando...",
        "success": "Restauração concluída com sucesso!"
      }
    }
  },
  "audit": {
    "page_title": "Registro de auditoria",
    "page_subtitle": "Veja todas as alterações feitas no seu espaço de trabalho.",
    "super_admin_label": "(Super Administrador)",
    "entries_count": "total de inscrições",
    "filter": {
      "action_label": "Tipo de ação",
      "all_actions": "Todas as ações",
      "entity_label": "Tipo de entidade",
      "all_entities": "Todas as entidades",
      "user_label": "Alterado por",
      "all_users": "Todos os usuários"
    },
    "action": {
      "user_updated": "Usuário atualizou",
      "user_deleted": "Usuário excluído",
      "user_imported": "Usuário Importado",
      "leave_requested": "Pedido de licença",
      "leave_approved": "Licença aprovada",
      "leave_rejected": "Licença rejeitada",
      "leave_cancelled": "Licença cancelada",
      "leave_type_created": "Tipo de saída criado",
      "leave_type_updated": "Tipo de saída atualizado",
      "leave_type_deleted": "Tipo de saída excluído",
      "balance_adjusted": "Saldo ajustado",
      "department_created": "Departamento criado",
      "department_updated": "Departamento atualizado",
      "department_deleted": "Departamento Excluído",
      "audit_log_deleted": "Registro de auditoria excluído"
    },
    "table": {
      "date": "Data",
      "user": "Usuário",
      "action": "Ação",
      "entity": "Entidade",
      "details": "Detalhes"
    },
    "no_entries": "Nenhuma entrada de log de auditoria encontrada"
  },
  "billing": {
    "page_title": "Faturamento e assinatura",
    "page_subtitle": "Gerencie seus dados de assinatura e faturamento.",
    "access_denied": {
      "title": "Acesso negado",
      "message": "Somente o proprietário do espaço de trabalho pode visualizar e gerenciar a fatura.",
      "button": "Voltar ao painel de controle"
    },
    "current_plan": {
      "title": "Plano atual"
    },
    "status": {
      "none": "Sem assinatura"
    },
    "discount_badge": "Desconto de {percent}% aplicado",
    "trial_info": {
      "title": "O julgamento termina em {date}",
      "days_remaining": "{dias} dias restantes"
    },
    "renewal_info": {
      "title": "Próxima data de faturamento"
    },
    "action": {
      "upgrade": "Faça o upgrade para a versão Pro.",
      "view_plans": "Ver todos os planos",
      "manage": "Gerenciar assinatura"
    },
    "plan": {
      "trial": "Teste grátis",
      "free": "Livre",
      "pro": "Pró",
      "business": "Negócios"
    },
    "feature": {
      "up_to_5_users": "Até 5 usuários",
      "up_to_50_users": "Até 50 usuários",
      "unlimited_users": "Usuários ilimitados",
      "basic": "Características básicas",
      "trial_14days": "Teste gratuito de 14 dias",
      "unlimited_requests": "Pedidos de licença ilimitados",
      "slack_integration": "Integração com o Slack",
      "planner": "Visão do planejador",
      "custom_leave_types": "Tipos de licença personalizados",
      "approval_workflows": "Fluxos de aprovação",
      "priority_support": "Suporte prioritário",
      "multi_team": "Suporte para várias equipes",
      "analytics": "Análises avançadas",
      "api_access": "Acesso à API",
      "dedicated_support": "Suporte dedicado"
    }
  },
  "upgrade": {
    "page_title": "Escolha o seu plano",
    "page_subtitle": "Preços simples e transparentes. Sem taxas por usuário.",
    "plan_badge": "Mais populares",
    "period": {
      "month": "/mês",
      "year": "/ano"
    },
    "yearly_savings": "ou EUR {anualmente}/ano (economize {por cento}%)",
    "loading": "Carregando planos...",
    "guarantee": {
      "title": "Garantia de reembolso de 30 dias",
      "description": "Não ficou satisfeito? Receba um reembolso total, sem perguntas."
    },
    "faq": {
      "title": "Perguntas frequentes",
      "q1": "Posso alterar meus planos mais tarde?",
      "a1": "Sim, você pode atualizar ou fazer downgrade a qualquer momento. As alterações entram em vigor imediatamente e são calculadas proporcionalmente.",
      "q2": "Quais métodos de pagamento vocês aceitam?",
      "a2": "Aceitamos todos os principais cartões de crédito (Visa, Mastercard, American Express) através do nosso provedor de pagamentos seguro, Stripe.",
      "q3": "Existe algum contrato ou compromisso?",
      "a3": "Não, todos os planos são mensais. Você pode cancelar a qualquer momento sem penalidades.",
      "q4": "O que acontece quando eu atinjo meu limite de usuários?",
      "a4": "Você será solicitado a atualizar para um plano superior. Os usuários atuais continuarão tendo acesso."
    },
    "contact_note": "Tem alguma dúvida? Entre em contato conosco pelo endereço:",
    "current_plan_badge": "Plano atual",
    "button": {
      "upgrade": "Faça upgrade para o plano {plan}",
      "start_trial": "Comece seu teste gratuito"
    }
  },
  "login": {
    "processing_title": "Você está fazendo login...",
    "processing_message": "Aguarde enquanto verificamos suas credenciais no Slack.",
    "subtitle": "Gerencie com facilidade os pedidos de férias da sua equipe.",
    "slack_button": "Adicionar ao Slack",
    "existing_user_text": "Já utiliza o Unplug?",
    "existing_user_info": "Abra o aplicativo no Slack e clique em Painel de administração para fazer login.",
    "terms_text": "Ao continuar",
    "error": {
      "workspace_not_found": "Espaço de trabalho não encontrado. Verifique o URL.",
      "invalid_response": "Resposta inválida do servidor",
      "generic": "falha no login",
      "please_retry": "Falha no login. Tente novamente."
    }
  },
  "help": {
    "page_title": "Central de Ajuda",
    "page_subtitle": "Encontre respostas e aprenda a usar o Unplug",
    "action": {
      "restart_tour": "Reiniciar a turnê"
    },
    "search": {
      "placeholder": "Pesquise artigos de ajuda, perguntas frequentes...",
      "results": "Encontrados {articles} artigos e {faqs} FAQs correspondentes a {query}"
    },
    "quick_link": {
      "getting_started": "Começando",
      "faqs": "Perguntas frequentes",
      "contact_support": "Contate o suporte",
      "tour": "Faça o tour"
    }
  },
  "profile": {
    "page_title": "Configurações de perfil",
    "personal_info": "Informações pessoais",
    "name_label": "Nome completo",
    "email_label": "E-mail",
    "department_label": "Departamento",
    "location_label": "Localização",
    "manager_label": "Gerente",
    "start_date_label": "Data de início",
    "save_button": "Salvar alterações",
    "preferences": "Preferências",
    "language_label": "Linguagem",
    "timezone_label": "Fuso horário"
  },
  "planner": {
    "page_title": "Planificador",
    "page_subtitle": "Calendário visual da equipa mostrando todas as ausências",
    "feature_name": "Planificador",
    "feature_description": "Calendário visual da equipa mostrando todas as ausências de relance",
    "empty_state": "Nenhum membro da equipa encontrado",
    "filter": {
      "pending_request": "Pedido pendente",
      "filter_by": "Filtrar por",
      "department": "Departamento",
      "all_departments": "Todos os departamentos",
      "location": "Localização",
      "all_locations": "Todas as localizações"
    },
    "export": {
      "button": "Exportar",
      "title": "Exportar dados de férias",
      "format": "Formato de exportação",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "CSV genérico",
      "date_range": "Intervalo de datas",
      "departments": "Departamentos"
    },
    "legend": {
      "approved": "Aprovado",
      "pending": "Pendente",
      "holiday": "Feriado",
      "holidays": "Feriados",
      "weekend": "Fim de semana",
      "non_working": "Dia não útil",
      "partial_day": "Ausências inferiores a um dia"
    },
    "no_data": "Sem ausências para mostrar"
  },
  "error": {
    "network": "Erro de rede. Por favor, verifique sua conexão.",
    "unauthorized": "Você não está autorizado a realizar esta ação.",
    "not_found": "O recurso solicitado não foi encontrado.",
    "server": "Erro no servidor. Tente novamente mais tarde.",
    "validation": "Por favor, verifique se há erros no formulário.",
    "generic": "Algo deu errado. Por favor, tente novamente.",
    "session_expired": "Sua sessão expirou. Por favor, faça login novamente."
  },
  "success": {
    "saved": "Alterações salvas com sucesso.",
    "deleted": "Excluído com sucesso.",
    "created": "Criado com sucesso.",
    "updated": "Atualização concluída com sucesso.",
    "submitted": "Enviado com sucesso.",
    "sent": "Enviado com sucesso."
  },
  "weekday": {
    "monday": "Segunda-feira",
    "tuesday": "Terça-feira",
    "wednesday": "Quarta-feira",
    "thursday": "Quinta-feira",
    "friday": "Sexta-feira",
    "saturday": "Sábado",
    "sunday": "Domingo",
    "mon": "seg",
    "tue": "ter",
    "wed": "qua",
    "thu": "qui",
    "fri": "sex",
    "sat": "Sentado",
    "sun": "Sol"
  },
  "month": {
    "january": "Janeiro",
    "february": "Fevereiro",
    "march": "Marchar",
    "april": "abril",
    "may": "Poderia",
    "june": "Junho",
    "july": "Julho",
    "august": "Agosto",
    "september": "Setembro",
    "october": "outubro",
    "november": "novembro",
    "december": "dezembro",
    "jan": "janeiro",
    "feb": "fevereiro",
    "mar": "Mar",
    "apr": "abril",
    "may_short": "Poderia",
    "jun": "junho",
    "jul": "julho",
    "aug": "agosto",
    "sep": "Setembro",
    "oct": "Outubro",
    "nov": "novembro",
    "dec": "Dezembro"
  },
  "language": {
    "en": "Inglês",
    "es": "Espanhol",
    "fr": "Francês",
    "de": "Alemão",
    "it": "italiano",
    "pt": "Português",
    "pl": "polonês",
    "nl": "Holandês",
    "sv": "sueco",
    "no": "norueguês"
  },
  "leave_type_name": {
    "Vacation": "Férias",
    "Vacation Leave": "Férias",
    "Annual Leave": "Férias anuais",
    "Unpaid Vacation": "Férias não remuneradas",
    "Unpaid Leave": "Licença não remunerada",
    "Sick Leave": "Licença médica",
    "Sick Leave (Full Pay)": "Licença médica (salário integral)",
    "Maternity Leave": "Licença maternidade",
    "Paternity Leave": "Licença paternidade",
    "Parental Leave": "Licença parental",
    "Bereavement Leave": "Licença por luto",
    "Marriage Leave": "Licença casamento",
    "Jury Leave": "Licença júri",
    "Jury Duty": "Serviço de júri",
    "Work Travel": "Viagem de trabalho",
    "Working Remotely": "Trabalho remoto",
    "Remote Work": "Trabalho remoto",
    "Work From Home": "Home office",
    "Personal Day": "Dia pessoal",
    "TOIL": "Folga compensatória",
    "Time Off In Lieu": "Folga compensatória",
    "Compassionate Leave": "Licença por motivos pessoais",
    "Study Leave": "Licença estudo",
    "Training": "Treinamento",
    "Public Holiday": "Feriado"
  }
}